import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// 創建public目錄下images目錄的別名，讓引用圖片更方便
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 註冊 Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW 註冊成功:', registration);
        
        // 檢查更新
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // 有新版本可用
                  console.log('新版本可用，請重新整理頁面');
                  if (window.confirm('有新版本可用，是否要重新整理頁面？')) {
                    window.location.reload();
                  }
                } else {
                  // 第一次安裝完成
                  console.log('已可離線使用');
                }
              }
            });
          }
        });
      })
      .catch((error) => {
        console.log('SW 註冊失敗:', error);
      });
  });

  // 監聽 SW 訊息
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SKIP_WAITING') {
      window.location.reload();
    }
  });
}

// PWA 安裝提示
let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  // 防止瀏覽器預設的安裝提示
  e.preventDefault();
  deferredPrompt = e;
  
  // 可以在這裡顯示自定義的安裝按鈕
  console.log('PWA 可以安裝');
});

// 安裝 PWA 函數
window.installPWA = async () => {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`用戶選擇: ${outcome}`);
    deferredPrompt = null;
  }
};

// 監聽 PWA 安裝完成
window.addEventListener('appinstalled', (e) => {
  console.log('PWA 已安裝');
  deferredPrompt = null;
});

// 效能監控
if ('performance' in window) {
  window.addEventListener('load', () => {
    // 使用 Performance Observer 監控
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (entry.entryType === 'largest-contentful-paint') {
            console.log('LCP:', entry.startTime);
          }
          if (entry.entryType === 'first-input') {
            console.log('FID:', entry.processingStart - entry.startTime);
          }
          if (entry.entryType === 'layout-shift') {
            if (!entry.hadRecentInput) {
              console.log('CLS:', entry.value);
            }
          }
        });
      });
      
      observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input', 'layout-shift'] });
    }
    
    // 基本效能指標
    setTimeout(() => {
      const perfData = window.performance.timing;
      const pageLoadTime = perfData.loadEventEnd - perfData.navigationStart;
      const domContentLoadedTime = perfData.domContentLoadedEventEnd - perfData.navigationStart;
      
      console.log(`頁面載入時間: ${pageLoadTime}ms`);
      console.log(`DOM 載入時間: ${domContentLoadedTime}ms`);
      
      // 發送到 GA (如果有設置)
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'timing_complete', {
          name: 'load',
          value: pageLoadTime
        });
      }
    }, 0);
  });
} 